import React from 'react';
import { useNavigate } from 'react-router-dom';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SavedInstitutesPanel = ({ savedInstitutes, onRemove }) => {
  const navigate = useNavigate();

  if (!savedInstitutes || savedInstitutes?.length === 0) {
    return (
      <div className="bg-card border border-border rounded-lg p-6 md:p-8">
        <div className="flex flex-col items-center justify-center text-center">
          <div className="w-16 h-16 md:w-20 md:h-20 bg-muted rounded-full flex items-center justify-center mb-4">
            <Icon name="Heart" size={32} color="var(--color-muted-foreground)" />
          </div>
          <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground mb-2">
            No Saved Institutes
          </h3>
          <p className="text-sm md:text-base text-muted-foreground max-w-sm">
            Save institutes you're interested in to quickly access them later
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden">
      <div className="p-4 md:p-5 border-b border-border">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Icon name="Heart" size={20} color="var(--color-accent)" />
            <h3 className="text-base md:text-lg font-heading font-semibold text-foreground">
              Saved Institutes
            </h3>
          </div>
          <span className="px-2.5 py-1 bg-accent/10 text-accent text-xs md:text-sm font-semibold rounded-full">
            {savedInstitutes?.length}
          </span>
        </div>
      </div>
      <div className="divide-y divide-border max-h-[400px] md:max-h-[500px] overflow-y-auto">
        {savedInstitutes?.map((institute) => (
          <div key={institute?.id} className="p-4 md:p-5 hover:bg-muted transition-smooth">
            <div className="flex gap-3 md:gap-4">
              <div className="flex-shrink-0 w-12 h-12 md:w-14 md:h-14 rounded-lg overflow-hidden bg-muted border border-border flex items-center justify-center">
                {institute?.logo ? (
                  <Image
                    src={institute?.logo}
                    alt={institute?.logoAlt || `${institute?.name} logo`}
                    className="w-full h-full object-contain p-1"
                  />
                ) : (
                  <Icon name="Building2" size={24} color="var(--color-primary)" />
                )}
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="text-sm md:text-base font-semibold text-foreground line-clamp-1 mb-1">
                  {institute?.name || 'Unknown Institute'}
                </h4>
                <p className="text-xs md:text-sm text-muted-foreground line-clamp-1 mb-2">
                  {institute?.location || 'Location not specified'}
                </p>
                <div className="flex flex-wrap gap-2">
                  <Button
                    variant="outline"
                    size="xs"
                    iconName="Store"
                    iconPosition="left"
                    onClick={() => navigate(`/virtual-booth/${institute?.id}`)}
                  >
                    Visit
                  </Button>
                  <Button
                    variant="ghost"
                    size="xs"
                    iconName="X"
                    iconPosition="left"
                    onClick={() => onRemove(institute?.id)}
                  >
                    Remove
                  </Button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SavedInstitutesPanel;